export default "__VITE_ASSET__CnthwS8q__"